/**
 * Check if search is a active parameter and changes searchfield
 */
 function checkSearchParameters() {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);

    if( params.has('zoekterm') ) {
        const search = params.get('zoekterm').split(',');
        $('.filter__search').val( search.join() ).trigger('change').trigger('input');
    }
}

/**
 * Search input on change event
 */
 $('.filter__search').on('input', function() {
    if( $(this).val() ) {
        $(this).next().addClass('has-value').find('.fas').addClass('fa-times').removeClass('fa-search');
    } else {
        $(this).next().removeClass('has-value').find('.fas').addClass('fa-search').removeClass('fa-times');
    }
});


/**
 * Page load event
 */
 $(document).ready(function() {
    if(  $('.filter__search').length != 0 ) {
        checkSearchParameters();
    }
})
